<template>
	<div id="advertiseView" class="statv_container statv_page_bg">
		<section class="statv_wrapper statv_page_wrapper">
			<h1 class="statv_page_title"> 광고문의 </h1>
			<figure class="contents_item">
				<p class="contents_title"> TV 채널 광고 단가 </p>
				<table class="ad_table">
					<thead>
						<tr style="height: 60px;">
							<td class="cell" style="flex: 2"> 구분 </td>
							<td class="cell"> 전/후CM </td>
							<td class="cell"> 중CM </td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="cell md"> 시급 </td>
							<td class="cell md"> 기준 </td>
							<td class="cell md"> <div class="icon spo_plus"/> </td>
							<td class="cell md"> <div class="icon spo_plus"/> </td>
						</tr>
						<tr>
							<td class="cell sm"> SSA </td>
							<td class="cell sm"> 11:00~17:59<br/>22:00~01:59  </td>
							<td class="cell sm"> 300,000 </td>
							<td class="cell sm"> 600,000 </td>
						</tr>
						<tr>
							<td class="cell sm"> SA </td>
							<td class="cell sm"> 02:00~03:59<br/>08:00~10:59<br/>18:00~21:59
							<td class="cell sm"> 200,000 </td> 
							<td class="cell sm"> 300,000 </td>
						</tr>
						<tr>
							<td class="cell sm"> A </td>
							<td class="cell sm"> 04:00~07:59 </td>
							<td class="cell sm"> 100,000 </td>
							<td class="cell sm"> 200,000 </td>
						</tr>
					</tbody>
				</table>
				<div class="contents_footer">
          <p class="footer_text">단위: 원 (VAT 별도)</br>※ 15초 기준 , 광고 길이에 따라 요금 변동</p>
				</div>
			</figure>
			<figure class="contents_item digital">
				<p class="contents_title"> DIGITAL - VOD 프리롤 단가 </p>
				<table class="ad_table">
					<thead>
						<tr style="height: 60px;">
							<td class="cell">TYPE</td>
							<td class="cell">PLATFORM</td>
							<td v-if="!isMobile"  class="cell">DURATION</td>
							<td class="cell">CPM</td>
							<td class="cell">최소집행금액</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="cell sm"> 리그타게팅 <br/> 5초 스킵 </td>
							<td class="cell sm"> Youtube </td>
							<td v-if="!isMobile"  class="cell sm"> 5” ~ 360” </td>
							<td class="cell sm"> 15,000 </td>
							<td class="cell sm"> 30,000,000 </td>
						</tr>
						<tr>
							<td class="cell sm"> 리그타게팅 <br/> 15초 논스킵 </td>
							<td class="cell sm"> Youtube </td>
							<td v-if="!isMobile"  class="cell sm"> 15” </td>
							<td class="cell sm"> 20,000 </td>
							<td class="cell sm"> 30,000,000 </td>
						</tr>
						<tr>
							<td class="cell sm"> 5초 스킵 </td>
							<td class="cell sm"> Youtube </td>
							<td v-if="!isMobile"  class="cell sm"> 5” ~ 360” </td>
							<td class="cell sm"> 13,000 </td>
							<td class="cell sm"> 10,000,000 </td>
						</tr>
						<tr>
							<td class="cell sm"> 15초 논스킵 </td>
							<td class="cell sm"> Youtube </td>
							<td v-if="!isMobile"  class="cell sm"> 15” </td>
							<td class="cell sm"> 15,000 </td>
							<td class="cell sm"> 10,000,000 </td>
						</tr>
					</tbody>
				</table>
				<div class="contents_footer">
          <p class="footer_text">단위: 원 (VAT 별도)</br>※ 콘텐츠 별 시즌 및 판권 계약에 따라 변동 가능</p>
				</div>
			</figure>
			<div class="ad_inquiry_information">
				<div class="inquiry_text"> 문의안내 </div>
        <div class="inquiry_email">
          <p><span>TV :</span> spo_tv@spotv.net <span>|</span><span> DIGITAL :</span> spo_online@spotv.net</p>
        </div>
			</div>
    </section>    
  </div>
</template>
<script>
import Utils from "@/helpers/utils.js";
export default {
  data() {
    return {
			isMobile: false,
    }
	},
	computed: {

	},
	created() {
		this.isMobile = Utils.isMobile()
	}
}
</script>
<style lang="less">
#advertiseView {
	.contents_item {
		margin-top: 50px;
		.contents_title {
			margin-bottom: 15px;
			margin-left: 15px;
			font-size: 22px;
			font-weight: 900;
			color: #ff6400;
		}
		.ad_table {
			display: flex;
			flex-flow: row wrap;
			border-collapse: collapse;
			thead, tbody {
				width: 100%;
				display: flex;
				flex-flow: column nowrap;
				justify-content: center;
				align-items: center;
				transform: skew(-0.05deg);
				tr {
					width: 100%;
					display: flex;
					flex-flow: row nowrap;
					justify-content: flex-start;
					align-items: center;
					td {
						display: flex;
						justify-content: center;
						align-items: center;
						flex: 1;
					}
				}
			}
			thead {
				margin: 0;
				border: none;
				padding: 0 15px;
				background-color: #ff6400;
				tr {
					td {
						font-size: 17px;
						font-weight: 600;
						padding: 0;
						&.cell {
							color: #FFFFFF;
							font-weight: 900;
							height: 32px;
						}
					}
				}
			}
			tbody {
				tr {
					border-bottom: 1px solid rgba(143, 143, 143, 0.3);
					td {
						text-align: center;
						font-size: 17px;
						&.cell.md {
							color: #ff6400;
							font-weight: normal;
							.icon {
								width: 100%;
								height: 60px;
								background-repeat: no-repeat;
								background-position: center;
                background-size: contain;
								&.spo {
									background-image: url("~@/assets/image/advertise/spotv_table_logo.png");
								}
								&.spo2 {
									background-image: url("~@/assets/image/advertise/spotv2_table_logo.png");
								}
								&.spo_plus {
									background-image: url("~@/assets/image/advertise/SPOTV PLUS_small.png");
								}
								&.statv {
									background-image: url("~@/assets/image/advertise/SPOTV K_logo_pc.png");
                  background-size:95px;
								}
							}
						}
						&.cell.sm {
							padding: 10px 0;
							color: #8F8F8F;
							font-weight: normal;

              &:first-child {
                color: #ff6400;
              }
						}
					}
				}
				&.icon {
					width: 382px;
					height: 60px;
					background-repeat: no-repeat;
					background-size: contain;
					background-position: center;
					&.spo {
						background-image: url("~@/assets/image/advertise/spotv_table_logo.png");
					}
					&.spo2 {
						background-image: url("~@/assets/image/advertise/spotv2_table_logo.png");
					}
					&.spo_plus {
						background-image: url("~@/assets/image/advertise/SPOTV PLUS_small.png");
					}
					&.statv {
						background-image: url("~@/assets/image/advertise/statv_table_logo.png");
					}
				}
			}
		}
		.contents_footer {
			display: flex;
			flex-flow: column wrap;
			padding-left: 15px;
			margin-top: 15px;
			transform: skew(-0.05deg);
			.footer_text {
				font-size: 14px;
				font-weight: 400;
				color: #ff6400;
				margin: 5px 0;
        line-height: 24px;
			}
		}
	}

  .digital {
    .ad_table {
			tbody {
				tr {
					td {
						&.cell.sm {
              &:first-child {
                color: #8f8f8f;
              }
						}
					}
				}
			}
		}
  }

  .ad_inquiry_information {
    display: flex;
    gap: 19px;
    margin-top: 50px;
    padding-left: 15px;
    font-size: 20px;
    color: #ff6400;

    .inquiry_text {
      font-weight: 900;
    }

    .inquiry_email {
      p {
        font-weight: 500;

        span {
          font-weight: 900;
        }
      }
    }
  }
}
.m #advertiseView {
	.contents_item {
		margin-top: 55px;
		padding: 0 15px;
		.contents_title {
			font-size: 34px;
			margin-left: 0;
		}
		.ad_table {
			.row {
				margin: 0;
				&.header {
					padding: 0;
				}
				&.flex1 {
					.cell {
						&.sm {
							height: 90px;
						}
						&:first-child {
							// flex: 0.5 0 0 !important;
						}
						&:nth-child(2) {
							flex: 2 0 0 !important;
						}
						&:nth-child(4) {
							flex: 0.8 0 0 !important;
						}
						&:last-child {
							flex: 2 0 0 !important;
						}
					}
					&.lg {
						.cell {
							&.sm {
								width: 100%;
								height: 90.5px;
							}
						}
					}
				}
				.cell {
					font-size: 20px;
					transform: skew(0.5deg);
				}
			}

      tbody {
				tr {
					td {
						&.cell.sm {
							padding: 10px 0;
							color: #8F8F8F;
							font-weight: normal;

              &:first-child {
                color: #ff6400;
              }

              &:nth-child(3),
              &:nth-child(4) {
                font-weight: bold;
              }
						}
					}
				}
			}
		}
		.contents_footer { 
			margin-top: 24px;

			.footer_text {
				font-size: 16px;
			}
		}
	}

  .digital {
    .ad_table {
			tbody {
				tr {
					td {
						&.cell.sm {
              &:first-child {
                color: #8f8f8f;
              }
						}
					}
				}
			}
		}
  }

  .ad_inquiry_information {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-top: 100px;
    margin-bottom: 160px;
    padding-left: 15px;

    .inquiry_text {
      height: 26px;
      font-size: 24px;
      font-weight: 900;
    }

    .inquiry_email {
      font-size: 24px;

      p {
        font-weight: 500;

        span {
          font-weight: 900;
        }
      }
    }
  }

	// .ad_footer {
	// 	padding-bottom: 160px;
	// 	font-size: 24px;
	// 	.footer_item {
	// 		transform: skew(0.5deg);
	// 		&:first-child {
	// 			width: 100%;
	// 		}
	// 	}
	// }
}
</style>